// Wrapper generated by the Propshaft migration: dependencies first, body last.
import './globals.js'
import './bootstrap_setup.js'
import './rails_ujs_setup.js'
import './toastr_setup.js'
import 'slick-carousel/slick/slick.min.js'
import 'intl-tel-input/build/js/intlTelInput-jquery.min.js'
import './swiper_setup.js'
import './chart_setup.js'
import './cable.js'
import './slick/home_carousel.js'
import './counterup_setup.js'
import './kpi_counter.js'
import 'waypoints/lib/jquery.waypoints.min.js'
import './subscriptions.js'
import './collect_countdown.js'
import './confirm_country_profile_update.js'
import './open_nav_item_with_url_anchor.js'
import './iframe_resizer_setup.js'
import './median_setup.js'
import './helpers.js'
import './chart_utils/pie_custom_legend_plugin.js'
import './chart_utils/pie_custom_legend_plugin_rebranding.js'
import './chart_utils/chart_defaults.js'
import './controllers/index.js'
import '@hotwired/turbo-rails'
import './powens-webview.js'
import './cable.body.js'
import './application.body.js'
